import { ColumnDef } from "@tanstack/react-table";
import { useLanguage } from "hooks";
import moment from "moment";
/* eslint-disable react-hooks/exhaustive-deps */
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ItemsTable } from "ui";

import { ProductBoxListItem } from "../../product.types";
import BoxZoneIcon from "./BoxZoneIcon";
import { BoxesTableProps } from "./BoxesTable.types";

import styles from "./BoxesTable.module.scss";

const BoxesTable = ({
  boxes,
  sorting,
  setSorting,
  isLoading,
}: BoxesTableProps) => {
  const { t } = useTranslation();
  const { currentLanguage } = useLanguage();
  const columns: Array<ColumnDef<ProductBoxListItem, ProductBoxListItem[]>> =
    useMemo(
      () => [
        {
          id: "name",
          accessorKey: "name",
          header: t("Box Name"),
          size: 42,
          minSize: 42,
          cell: ({ row }) => {
            const box = boxes[row.index];
            return (
              <div className={styles.boxesTable_nameCell}>
                <span
                  className={styles.boxesTable_zoneIcon}
                  title={
                    box.zone === "Warehouse" ? t("Warehouse") : t("Pickup")
                  }
                >
                  <BoxZoneIcon zone={box.zone} size={30} />
                </span>
                <span>{box.name ?? "-"}</span>
              </div>
            );
          },
        },
        {
          id: "type",
          accessorKey: "type",
          header: t("Box Type"),
          size: 14,
          minSize: 14,
          cell: ({ row }) => <div>{boxes[row.index].type ?? "-"}</div>,
        },
        {
          id: "itemsCount",
          accessorKey: "itemsCount",
          header: t("Items"),
          size: 14,
          minSize: 14,
          cell: ({ row }) => boxes[row.index].itemsCount,
        },
        {
          id: "createdAt",
          accessorKey: "createdAt",
          header: t("Created"),
          size: 15,
          minSize: 15,
          cell: ({ row }) => (
            <pre>
              {moment(boxes[row.index].createdAt).format("DD/MM/YYYY HH:mm")}
            </pre>
          ),
        },
        {
          id: "updatedAt",
          accessorKey: "updatedAt",
          header: t("Edited"),
          size: 15,
          minSize: 15,
          cell: ({ row }) => (
            <pre>
              {moment(boxes[row.index].updatedAt).format("DD/MM/YYYY HH:mm")}
            </pre>
          ),
        },
      ],
      [boxes, currentLanguage],
    );

  return (
    <ItemsTable
      className={styles.boxesTable}
      columns={columns}
      data={boxes}
      sorting={sorting}
      skeletonHeight={70}
      setSorting={setSorting}
      isLoading={isLoading}
    />
  );
};

export default BoxesTable;
